import { render, staticRenderFns } from "./KirmiziSantralChannels.vue?vue&type=template&id=0ba85a2e&scoped=true"
import script from "./KirmiziSantralChannels.vue?vue&type=script&lang=js"
export * from "./KirmiziSantralChannels.vue?vue&type=script&lang=js"
import style0 from "./KirmiziSantralChannels.vue?vue&type=style&index=0&id=0ba85a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba85a2e",
  null
  
)

export default component.exports